// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__wfljr","label":"styles_label__cKhHy","input":"styles_input__nZRqK","btn_submit":"styles_btn_submit__5-SJr"};